// src/mazot-takip/src/pages/TankIkmal.js
import React, { useEffect, useMemo, useState } from "react";
import { db, auth } from "../firebaseConfig";
import {
  collection, getDocs, addDoc, serverTimestamp, Timestamp,
  query, where, doc, getDoc, updateDoc, arrayUnion, orderBy
} from "firebase/firestore";

/** Roller */
const ROLES = { VIEW:"view", ONLY_INPUT:"only_input", INPUT_APPROVE:"input_approve", CREATOR:"creator" };

/** Yardımcılar */
function normalize(s=""){return s.toString().toUpperCase()
  .replaceAll("İ","I").replaceAll("ı","I").replaceAll("Ş","S").replaceAll("ş","S")
  .replaceAll("Ğ","G").replaceAll("ğ","G").replaceAll("Ü","U").replaceAll("ü","U")
  .replaceAll("Ö","O").replaceAll("ö","O").replaceAll("Ç","C").replaceAll("ç","C").trim();}
function parseNumber(v){ if(v===null||v===undefined) return null; const n=Number(String(v).replace(",",".")); return Number.isFinite(n)?n:null; }
function getISODate(d=new Date()){const p=x=>String(x).padStart(2,"0");return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;}
function getDateOnly(d=new Date()){const p=x=>String(x).padStart(2,"0");return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}`;}
function firstOfPrevMonth(){
  const d=new Date();
  d.setDate(1);
  d.setMonth(d.getMonth()-1);
  return getDateOnly(d);
}
function toDateTimeInput(val){
  const d = val?.toDate?.() || new Date(val || Date.now());
  if (isNaN(d.getTime())) return getISODate(new Date()).slice(0,16);
  return getISODate(d).slice(0,16);
}
const fmt = (n) => new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(Number(n || 0));
const toMs = (v) => v?.toDate?.()?.getTime?.() ?? new Date(v || 0).getTime();
const normText = (v) => normalize(String(v ?? ""));
const fmtDate = (v) => {
  const d = v?.toDate?.() || new Date(v || 0);
  return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("tr-TR");
};

/** Rol oku */
async function fetchUserMazotRole(email){
  try{
    if(!email) return ROLES.VIEW;
    const snap1 = await getDoc(doc(db,"users",email));
    let data = snap1.exists()? snap1.data(): null;
    if(!data){
      const snap2 = await getDocs(query(collection(db,"users"), where("email","==",email)));
      if(!snap2.empty) data = snap2.docs[0].data();
    }
    const m = data?.["mazot-takip"] || data?.["mazot_takip"] || {};
    if(m.olusturucu) return ROLES.CREATOR;
    if(m.giren_onaylayan) return ROLES.INPUT_APPROVE;
    if(m.giren) return ROLES.ONLY_INPUT;
    if(m.izleyen) return ROLES.VIEW;
    return ROLES.VIEW;
  }catch{ return ROLES.VIEW; }
}

/** Listeler */
async function fetchTesisler(){
  const snap=await getDocs(collection(db,"tesisler"));
  return snap.docs.map(d=>({id:d.id,...(d.data()||{})}))
    .filter(x=>x.active!==false)
    .map(x=>x.name||x.ad||x.title||"")
    .filter(Boolean);
}
async function fetchActiveTanks(){
  const snap=await getDocs(collection(db,"fuel_tanks"));
  return snap.docs.map(d=>({id:d.id,...(d.data()||{})}))
    .filter(x=>x.active!==false)
    .map(x=>({id:x.id,name:x.name||x.tankAdi||"TANK",tesis:x.tesis||"",capacity:x.capacity||null}));
}

export default function TankIkmal(){
  const [role,setRole]=useState(null);
  const [tesisFromColl,setTesisFromColl]=useState([]); // tesisler koleksiyonu
  const [tanks,setTanks]=useState([]);
  const [listRows,setListRows]=useState([]);
  const [listLoading,setListLoading]=useState(false);
  const [fStart,setFStart]=useState(firstOfPrevMonth());
  const [fEnd,setFEnd]=useState(getDateOnly());
  const [fTesis,setFTesis]=useState("ALL");
  const [editForm,setEditForm]=useState(null);
  const [openFilter,setOpenFilter]=useState(null);
  const [filterPos,setFilterPos]=useState(null);
  const [tableFilters,setTableFilters]=useState({});
  const [tableSort,setTableSort]=useState({ key:null, dir:null });

  const [form,setForm]=useState({
    tesis:"",
    date:getISODate(new Date()).slice(0,16),
    liters:"",
    unitPrice:"",     // ZORUNLU
    temperatureC:"",  // ops.
    supplier:"",      // ops.
    invoiceNumber:"", // ops.
    notes:"",         // ops.
  });

  useEffect(()=>{
    fetchUserMazotRole(auth.currentUser?.email).then(setRole);
    Promise.all([fetchTesisler(), fetchActiveTanks()]).then(([te,tk])=>{
      setTesisFromColl(te); setTanks(tk);
    });
  },[]);

  const canCreate = [ROLES.INPUT_APPROVE, ROLES.CREATOR].includes(role);
  const canEdit = canCreate;

  // Her tesis için tek tank varsayımı
  const tankByTesis = useMemo(()=>{
    const m=new Map();
    tanks.forEach(t=>{
      const key=normalize(t.tesis||"");
      if(!m.has(key)) m.set(key,[]);
      m.get(key).push(t);
    });
    return m;
  },[tanks]);

  // Datalist için TESİS seçenekleri = tesisler ∪ tank.tesis (unique)
  const tesisOptions = useMemo(()=>{
    const set = new Set();
    tesisFromColl.forEach(n=> n && set.add(n));
    tanks.forEach(t=> t.tesis && set.add(t.tesis));
    return Array.from(set).sort((a,b)=>a.localeCompare(b,"tr"));
  },[tesisFromColl, tanks]);

  const onChange=(k,v)=>setForm(s=>({...s,[k]:v}));

  const invoiceWarning = async (invoiceNumber, currentId=null) => {
    const inv = String(invoiceNumber || "").trim();
    if(!inv) return true;
    try{
      const snap = await getDocs(query(collection(db,"fuel_deliveries"), where("invoiceNumber","==",inv)));
      const others = snap.docs.filter(d => d.id !== currentId);
      if(others.length){
        return window.confirm(`Bu fatura no (${inv}) daha once ${others.length} kayitta kullanilmis. Yine de devam edilsin mi?`);
      }
    }catch{}
    return true;
  };

  async function handleSave(){
    if(!canCreate) return alert("Bu işlem için yetkiniz yok.");
    if(!form.tesis) return alert("Tesis seçiniz.");

    const key=normalize(form.tesis);
    const arr=tankByTesis.get(key)||[];
    let tankId=null, tankName=null;
    if(arr.length>=1){ tankId=arr[0].id; tankName=arr[0].name; } // tek tank varsayımı

    const liters=parseNumber(form.liters);
    if(!liters || liters<=0) return alert("Litre > 0 olmalı.");

    const unitPrice=parseNumber(form.unitPrice);
    if(!unitPrice || unitPrice<=0) return alert("Birim fiyat (TL/L) zorunludur.");

    const okInvoice = await invoiceWarning(form.invoiceNumber);
    if(!okInvoice) return;

    await addDoc(collection(db,"fuel_deliveries"),{
      tesis: form.tesis,
      tankId, tankName,
      date: Timestamp.fromDate(new Date(form.date)),
      liters, unitPrice,
      temperatureC: form.temperatureC? parseNumber(form.temperatureC): null,
      supplier: form.supplier || null,
      invoiceNumber: form.invoiceNumber || null,
      notes: form.notes || null,
      createdBy: auth.currentUser?.email || "anonim",
      createdAt: serverTimestamp(),
    });

    alert("İkmal kaydı eklendi ✅");
    setForm(s=>({...s, liters:"", unitPrice:"", temperatureC:"", supplier:"", invoiceNumber:"", notes:""}));
    loadList();
  }

  async function loadList(){
    setListLoading(true);
    try{
      const start = new Date(`${fStart}T00:00:00`);
      const end = new Date(`${fEnd}T23:59:59`);
      const tsStart = Timestamp.fromDate(start);
      const tsEnd = Timestamp.fromDate(end);
      let docs = [];
      try{
        const q1 = query(
          collection(db,"fuel_deliveries"),
          where("date",">=",tsStart),
          where("date","<=",tsEnd),
          orderBy("date","desc")
        );
        const snap = await getDocs(q1);
        docs = snap.docs;
      }catch{
        const snap = await getDocs(collection(db,"fuel_deliveries"));
        docs = snap.docs.filter(d=>{
          const row = d.data() || {};
          const ms = row.date?.toDate?.()?.getTime?.() ?? new Date(row.date || 0).getTime();
          return ms >= start.getTime() && ms <= end.getTime();
        });
      }

      let rows = docs.map(d=>({id:d.id, ...(d.data()||{})}));
      if(fTesis !== "ALL") rows = rows.filter(r => (r.tesis || "") === fTesis);
      rows.sort((a,b)=>{
        const am = a.date?.toDate?.()?.getTime?.() ?? new Date(a.date || 0).getTime();
        const bm = b.date?.toDate?.()?.getTime?.() ?? new Date(b.date || 0).getTime();
        return bm - am;
      });
      setListRows(rows);
    }finally{
      setListLoading(false);
    }
  }

  useEffect(()=>{ loadList(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [fStart, fEnd, fTesis]);

  function startEdit(row){
    setEditForm({
      id: row.id,
      tesis: row.tesis || "",
      date: toDateTimeInput(row.date),
      liters: row.liters ?? "",
      unitPrice: row.unitPrice ?? "",
      temperatureC: row.temperatureC ?? "",
      supplier: row.supplier || "",
      invoiceNumber: row.invoiceNumber || "",
      notes: row.notes || "",
      _raw: row,
    });
  }

  function diffChanges(before, after){
    const keys=["date","tesis","tankId","tankName","liters","unitPrice","temperatureC","supplier","invoiceNumber","notes"];
    const changes={};
    keys.forEach(k=>{
      const oldVal = k==="date" ? toDateTimeInput(before[k]) : (before[k] ?? "");
      const newVal = k==="date" ? toDateTimeInput(after[k]) : (after[k] ?? "");
      if(String(oldVal) !== String(newVal)) changes[k]=[oldVal,newVal];
    });
    return changes;
  }

  async function handleUpdate(){
    if(!canEdit || !editForm) return alert("Yetkiniz yok.");
    if(!editForm.tesis) return alert("Tesis seciniz.");
    if(!editForm.date) return alert("Tarih zorunlu.");

    const key=normalize(editForm.tesis);
    const arr=tankByTesis.get(key)||[];
    let tankId=null, tankName=null;
    if(arr.length>=1){ tankId=arr[0].id; tankName=arr[0].name; }

    const liters=parseNumber(editForm.liters);
    if(!liters || liters<=0) return alert("Litre > 0 olmali.");

    const unitPrice=parseNumber(editForm.unitPrice);
    if(!unitPrice || unitPrice<=0) return alert("Birim fiyat (TL/L) zorunludur.");

    const okInvoice = await invoiceWarning(editForm.invoiceNumber, editForm.id);
    if(!okInvoice) return;

    const payload={
      tesis: editForm.tesis,
      tankId,
      tankName,
      date: Timestamp.fromDate(new Date(editForm.date)),
      liters,
      unitPrice,
      temperatureC: editForm.temperatureC ? parseNumber(editForm.temperatureC) : null,
      supplier: editForm.supplier || null,
      invoiceNumber: editForm.invoiceNumber || null,
      notes: editForm.notes || null,
      updatedBy: auth.currentUser?.email || "anonim",
      updatedAt: serverTimestamp(),
    };
    const afterForDiff={...editForm._raw, ...payload};
    const changes=diffChanges(editForm._raw, afterForDiff);
    if(Object.keys(changes).length===0) return alert("Degisen alan yok.");

    await updateDoc(doc(db,"fuel_deliveries",editForm.id),{
      ...payload,
      history: arrayUnion({
        action:"update",
        by: auth.currentUser?.email || "anonim",
        at: Timestamp.now(),
        changes,
      }),
    });

    alert("Ikmal kaydi guncellendi.");
    setEditForm(null);
    loadList();
  }

  const listColumns = [
    { key:"action", label:"Islem", type:"text" },
    { key:"date", label:"Tarih", type:"date" },
    { key:"createdAt", label:"Kayit Zamani", type:"date" },
    { key:"tesis", label:"Tesis", type:"text" },
    { key:"tankName", label:"Tank", type:"text" },
    { key:"liters", label:"Litre", type:"number" },
    { key:"unitPrice", label:"Birim Fiyat", type:"number" },
    { key:"supplier", label:"Tedarikci", type:"text" },
    { key:"invoiceNumber", label:"Fatura", type:"text" },
    { key:"createdBy", label:"Kaydeden", type:"text" },
  ];

  const cellValue = (row, key) => {
    if(key==="date") return toMs(row.date);
    if(key==="createdAt") return toMs(row.createdAt);
    return row[key];
  };

  const displayValue = (row, key) => {
    if(key==="date") return fmtDate(row.date);
    if(key==="createdAt") return fmtDate(row.createdAt);
    return cellValue(row,key) ?? "";
  };

  const visibleRows = useMemo(()=>{
    let rows=[...listRows];
    Object.entries(tableFilters).forEach(([key,cfg])=>{
      if(!cfg) return;
      const col=listColumns.find(c=>c.key===key);
      if(!col) return;
      if(col.type==="number"){
        const target=parseNumber(cfg.value);
        if(target==null || !cfg.op) return;
        rows=rows.filter(r=>{
          const v=Number(cellValue(r,key));
          if(!Number.isFinite(v)) return false;
          if(cfg.op==="gt") return v>target;
          if(cfg.op==="lt") return v<target;
          return v===target;
        });
      }else{
        const q=normText(cfg.search);
        const selected=Array.isArray(cfg.selected) ? cfg.selected : null;
        if(!q && !selected) return;
        rows=rows.filter(r=>{
          const raw=String(displayValue(r,key) || "");
          const searchOk=!q || normText(raw).includes(q);
          const selectedOk=!selected || selected.includes(raw);
          return searchOk && selectedOk;
        });
      }
    });
    if(tableSort.key){
      const col=listColumns.find(c=>c.key===tableSort.key);
      rows.sort((a,b)=>{
        const av=cellValue(a,tableSort.key);
        const bv=cellValue(b,tableSort.key);
        const res=col?.type==="number" || col?.type==="date"
          ? Number(av||0)-Number(bv||0)
          : String(av||"").localeCompare(String(bv||""),"tr");
        return tableSort.dir==="asc" ? res : -res;
      });
    }
    return rows;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listRows, tableFilters, tableSort]);

  const filterOptionsFor = (key) => {
    const q=normText(tableFilters[key]?.search || "");
    const set=new Set();
    listRows.forEach(r=>{
      const v=String(displayValue(r,key) || "-");
      if(!q || normText(v).includes(q)) set.add(v);
    });
    return Array.from(set).sort((a,b)=>a.localeCompare(b,"tr"));
  };

  const toggleFilterOption = (key, value) => {
    setTableFilters(prev=>{
      const allValues=Array.from(new Set(listRows.map(r=>String(displayValue(r,key) || "-"))));
      const current=Array.isArray(prev[key]?.selected) ? prev[key].selected : allValues;
      const selected=current.includes(value) ? current.filter(v=>v!==value) : [...current, value];
      return {...prev,[key]:{...(prev[key]||{}),selected,search:prev[key]?.search || ""}};
    });
  };

  const openColumnFilter = (key, e) => {
    e.stopPropagation();
    const rect=e.currentTarget.getBoundingClientRect();
    setOpenFilter(openFilter===key ? null : key);
    setFilterPos({ top:rect.bottom+6, left:Math.min(rect.left, window.innerWidth-240), width:220 });
  };

  const toggleSort = (key) => {
    setTableSort(prev => {
      if(prev.key!==key) return { key, dir:"asc" };
      if(prev.dir==="asc") return { key, dir:"desc" };
      return { key:null, dir:null };
    });
  };

  const clearColumnFilter = (key) => {
    setTableFilters(prev=>({...prev,[key]:undefined}));
    if(tableSort.key===key) setTableSort({key:null, dir:null});
  };

  useEffect(()=>{
    if(!openFilter) return;
    const close=()=>setOpenFilter(null);
    window.addEventListener("click", close);
    return ()=>window.removeEventListener("click", close);
  },[openFilter]);

  // --- Basit stil objeleri (yalnızca görünüm) ---
  const styles = {
    page: {
      padding: 20,
      paddingTop: 88,            // fixed navbar varsa örtüşmeyi engeller
      maxWidth: 1320,
      margin: "0 auto",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: 16,                   // hem yatay hem dikey boşluk
      alignItems: "start",
    },
    field: {
      display: "flex",
      flexDirection: "column",
      gap: 6,                    // label-input arası boşluk
      minWidth: 0,
    },
    label: {
      fontSize: 12,
      color: "#334155",
      fontWeight: 600,
    },
    input: {
      width: "100%",
      border: "1px solid #cbd5e1",
      padding: 10,
      borderRadius: 8,
      boxSizing: "border-box",
      lineHeight: "20px",
    },
    fullRow: {
      gridColumn: "1 / -1",
    },
    saveBtn: {
      backgroundColor: "#4f46e5",
      color: "white",
      padding: "10px 20px",
      fontWeight: "bold",
      borderRadius: 8,
      border: "none",
      cursor: "pointer",
      marginTop: 16,
    },
    title: {
      textAlign: "left",
      color: "#334155",
      fontSize: 22,
      fontWeight: "bold",
      marginBottom: 20,
    }
  };

  return (
    <div style={styles.page}>
      <style>{`
        .tank-filter-btn{ width:22px; height:20px; border:1px solid #cbd5e1; border-radius:6px; background:linear-gradient(#fff,#f1f5f9); color:#334155; cursor:pointer; font-size:12px; line-height:16px; padding:0; box-shadow:0 1px 1px rgba(15,23,42,.08); }
        .tank-filter-btn:hover,.tank-filter-btn.open{ background:#dbeafe; border-color:#60a5fa; color:#1d4ed8; }
        .tank-filter-btn.active{ background:#bfdbfe; border-color:#3b82f6; color:#1e40af; }
        .tank-filter-btn.sort-asc{ background:#ffedd5; border-color:#fdba74; color:#9a3412; }
        .tank-filter-btn.sort-desc{ background:#dbeafe; border-color:#93c5fd; color:#1e40af; }
        .tank-filter-menu{ position:fixed; background:#fff; border:1px solid #cbd5e1; border-radius:8px; box-shadow:0 12px 28px rgba(15,23,42,.18); z-index:9999; font-size:12px; padding:10px; max-height:360px; overflow:auto; }
        .tank-filter-menu input,.tank-filter-menu select{ width:100%; box-sizing:border-box; border:1px solid #cbd5e1; border-radius:6px; padding:6px; font-size:12px; background:#fff; }
        .tank-filter-menu button{ border:1px solid #cbd5e1; background:#fff; border-radius:6px; padding:6px; font-size:12px; cursor:pointer; }
        .tank-filter-menu button:hover{ background:#f1f5f9; }
        .tank-filter-title{ font-weight:700; color:#0f172a; margin-bottom:8px; }
        .tank-filter-options{ display:grid; gap:5px; max-height:170px; overflow:auto; border:1px solid #e5e7eb; border-radius:6px; padding:6px; background:#f8fafc; }
        .tank-filter-option{ display:flex; align-items:center; gap:6px; color:#334155; }
      `}</style>
      <h2 style={styles.title}>Tank İkmal</h2>

      <div style={styles.grid}>
        <div style={styles.field}>
          <label style={styles.label}>Tesis</label>
          <input
            list="dl-tesisler"
            value={form.tesis}
            onChange={e=>onChange("tesis",e.target.value)}
            style={styles.input}
          />
          <datalist id="dl-tesisler">
            {tesisOptions.map(name=> <option key={name} value={name}/>)}
          </datalist>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Tarih/Saat</label>
          <input
            type="datetime-local"
            value={form.date}
            onChange={e=>onChange("date",e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Litre</label>
          <input
            type="number" step="0.01"
            value={form.liters}
            onChange={e=>onChange("liters",e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Birim Fiyat (TL/L) <b style={{color:"#b91c1c"}}>*</b></label>
          <input
            type="number" step="0.001"
            value={form.unitPrice}
            onChange={e=>onChange("unitPrice",e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Sıcaklık (°C) (ops.)</label>
          <input
            type="number" step="0.1"
            value={form.temperatureC}
            onChange={e=>onChange("temperatureC",e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Tedarikçi (ops.)</label>
          <input
            value={form.supplier}
            onChange={e=>onChange("supplier",e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Fatura No (ops.)</label>
          <input
            value={form.invoiceNumber}
            onChange={e=>onChange("invoiceNumber",e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={{...styles.field, ...styles.fullRow}}>
          <label style={styles.label}>Not (ops.)</label>
          <input
            value={form.notes}
            onChange={e=>onChange("notes",e.target.value)}
            style={styles.input}
          />
        </div>
      </div>

      <div>
        <button onClick={handleSave} style={styles.saveBtn}>Kaydet</button>
      </div>

      <hr style={{ margin:"28px 0", border:0, borderTop:"1px solid #e5e7eb" }} />

      <h3 style={{ fontSize:18, fontWeight:"bold", color:"#334155", marginBottom:12 }}>Ikmal Kayitlari</h3>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:12, marginBottom:12 }}>
        <div style={styles.field}>
          <label style={styles.label}>Baslangic</label>
          <input type="date" value={fStart} onChange={e=>setFStart(e.target.value)} style={styles.input} />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Bitis</label>
          <input type="date" value={fEnd} onChange={e=>setFEnd(e.target.value)} style={styles.input} />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Tesis</label>
          <select value={fTesis} onChange={e=>setFTesis(e.target.value)} style={{...styles.input, background:"#fff"}}>
            <option value="ALL">Tumu</option>
            {tesisOptions.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      </div>

      <div style={{ overflowX:"auto" }}>
        <table style={{ borderCollapse:"collapse", width:"100%", minWidth:1060, fontSize:13 }}>
          <thead style={{ background:"#eef2f7" }}>
            <tr>
              {listColumns.map((col)=>(
                <th key={col.key} style={{ border:"1px solid #e5e7eb", padding:8, textAlign:"left", whiteSpace:"nowrap" }}>
                  <span style={{ display:"inline-flex", alignItems:"center", gap:6 }}>
                    {col.label}
                    {col.key!=="action" && (
                      <button
                        className={`tank-filter-btn ${openFilter===col.key ? "open" : ""} ${tableFilters[col.key] ? "active" : ""} ${tableSort.key===col.key ? (tableSort.dir==="asc"?"sort-asc":"sort-desc") : ""}`}
                        onClick={(e)=>openColumnFilter(col.key,e)}
                        title="Filtrele ve sirala"
                      >
                        ▾
                      </button>
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {listLoading ? (
              <tr><td colSpan={10} style={{ padding:12, textAlign:"center", color:"#64748b" }}>Yukleniyor...</td></tr>
            ) : visibleRows.length===0 ? (
              <tr><td colSpan={10} style={{ padding:12, textAlign:"center", color:"#64748b" }}>Kayit bulunamadi</td></tr>
            ) : (
              visibleRows.map(r=>{
                return (
                  <tr key={r.id} style={{ background: editForm?.id===r.id ? "#eef2ff" : "transparent" }}>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>
                      <button
                        onClick={()=>startEdit(r)}
                        disabled={!canEdit}
                        style={{ border:"1px solid #94a3b8", background:"#fff", borderRadius:6, padding:"5px 9px", cursor:canEdit?"pointer":"not-allowed" }}
                      >
                        Duzelt
                      </button>
                    </td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{fmtDate(r.date)}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{fmtDate(r.createdAt)}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{r.tesis || "-"}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{r.tankName || "-"}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6, textAlign:"right" }}>{fmt(r.liters)}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6, textAlign:"right" }}>{fmt(r.unitPrice)}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{r.supplier || "-"}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{r.invoiceNumber || "-"}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{r.createdBy || "-"}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {openFilter && filterPos && (() => {
        const col=listColumns.find(c=>c.key===openFilter);
        const cfg=tableFilters[openFilter] || {};
        if(!col) return null;
        return (
          <div
            className="tank-filter-menu"
            style={{ top:filterPos.top, left:filterPos.left, width:filterPos.width }}
            onClick={(e)=>e.stopPropagation()}
          >
            <div className="tank-filter-title">{col.label}</div>
            <div style={{ display:"grid", gap:8 }}>
              <button
                className={tableSort.key===col.key ? (tableSort.dir==="asc" ? "tank-filter-btn sort-asc" : "tank-filter-btn sort-desc") : ""}
                style={{ width:"100%" }}
                onClick={()=>toggleSort(col.key)}
              >
                {tableSort.key===col.key ? (tableSort.dir==="asc" ? "Kucukten buyuge / A-Z" : "Buyukten kucuge / Z-A") : "Sirala"}
              </button>
              {col.type==="number" ? (
                <>
                  <select
                    value={cfg.op || ""}
                    onChange={e=>setTableFilters(prev=>({...prev,[col.key]:{...(prev[col.key]||{}),op:e.target.value}}))}
                  >
                    <option value="">Filtre yok</option>
                    <option value="gt">Buyuktur</option>
                    <option value="lt">Kucuktur</option>
                    <option value="eq">Esittir</option>
                  </select>
                  <input
                    type="text"
                    inputMode="decimal"
                    value={cfg.value || ""}
                    onChange={e=>setTableFilters(prev=>({...prev,[col.key]:{...(prev[col.key]||{}),value:e.target.value}}))}
                    placeholder="Deger"
                  />
                </>
              ) : (
                <>
                  <input
                    value={cfg.search || ""}
                    onChange={e=>setTableFilters(prev=>({...prev,[col.key]:{...(prev[col.key]||{}),search:e.target.value}}))}
                    placeholder="Ara..."
                  />
                  <div className="tank-filter-options">
                    {filterOptionsFor(col.key).length===0 ? (
                      <div style={{ color:"#64748b" }}>Secenek yok</div>
                    ) : filterOptionsFor(col.key).map(v=>{
                      const allValues=Array.from(new Set(listRows.map(r=>String(displayValue(r,col.key) || "-"))));
                      const selected=Array.isArray(cfg.selected) ? cfg.selected : allValues;
                      return (
                        <label key={v} className="tank-filter-option">
                          <input
                            type="checkbox"
                            checked={selected.includes(v)}
                            onChange={()=>toggleFilterOption(col.key,v)}
                            style={{ width:"auto" }}
                          />
                          <span>{v}</span>
                        </label>
                      );
                    })}
                  </div>
                </>
              )}
              <button onClick={()=>clearColumnFilter(col.key)}>Temizle</button>
            </div>
          </div>
        );
      })()}

      {editForm && (
        <div style={{ marginTop:18, border:"1px solid #c7d2fe", borderRadius:8, padding:14, background:"#f8fafc" }}>
          <h3 style={{ marginTop:0, color:"#334155" }}>Ikmal Kaydi Duzelt</h3>
          <div style={styles.grid}>
            <div style={styles.field}>
              <label style={styles.label}>Tesis</label>
              <input list="dl-tesisler" value={editForm.tesis} onChange={e=>setEditForm(s=>({...s, tesis:e.target.value}))} style={styles.input} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Tarih/Saat</label>
              <input type="datetime-local" value={editForm.date} onChange={e=>setEditForm(s=>({...s, date:e.target.value}))} style={styles.input} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Litre</label>
              <input type="number" step="0.01" value={editForm.liters} onChange={e=>setEditForm(s=>({...s, liters:e.target.value}))} style={styles.input} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Birim Fiyat</label>
              <input type="number" step="0.001" value={editForm.unitPrice} onChange={e=>setEditForm(s=>({...s, unitPrice:e.target.value}))} style={styles.input} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Sicaklik</label>
              <input type="number" step="0.1" value={editForm.temperatureC} onChange={e=>setEditForm(s=>({...s, temperatureC:e.target.value}))} style={styles.input} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Tedarikci</label>
              <input value={editForm.supplier} onChange={e=>setEditForm(s=>({...s, supplier:e.target.value}))} style={styles.input} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Fatura No</label>
              <input value={editForm.invoiceNumber} onChange={e=>setEditForm(s=>({...s, invoiceNumber:e.target.value}))} style={styles.input} />
            </div>
            <div style={{...styles.field, ...styles.fullRow}}>
              <label style={styles.label}>Not</label>
              <input value={editForm.notes} onChange={e=>setEditForm(s=>({...s, notes:e.target.value}))} style={styles.input} />
            </div>
          </div>
          <div style={{ display:"flex", gap:10, marginTop:12 }}>
            <button onClick={handleUpdate} style={styles.saveBtn}>Guncelle</button>
            <button onClick={()=>setEditForm(null)} style={{...styles.saveBtn, background:"#64748b"}}>Vazgec</button>
          </div>

          <h4 style={{ marginBottom:8, color:"#334155" }}>Log Kayitlari</h4>
          {Array.isArray(editForm._raw?.history) && editForm._raw.history.length>0 ? (
            <table style={{ borderCollapse:"collapse", width:"100%", fontSize:13 }}>
              <thead style={{ background:"#e2e8f0" }}>
                <tr>{["Islem","Kullanici","Zaman","Degisiklikler"].map(h=><th key={h} style={{ border:"1px solid #cbd5e1", padding:6, textAlign:"left" }}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {editForm._raw.history.map((h,idx)=>(
                  <tr key={idx}>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{h.action || "-"}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{h.by || "-"}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6 }}>{h.at?.toDate ? h.at.toDate().toLocaleString("tr-TR") : "-"}</td>
                    <td style={{ border:"1px solid #e5e7eb", padding:6, whiteSpace:"pre-wrap" }}>
                      {h.changes ? Object.entries(h.changes).map(([k,v])=>`${k}: '${Array.isArray(v)?v[0]:""}' -> '${Array.isArray(v)?v[1]:""}'`).join("\n") : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ color:"#64748b", fontSize:13 }}>Bu kayit icin log bulunamadi.</div>
          )}
        </div>
      )}
    </div>
  );
}
